module.exports = __webpack_public_path__ + "55fcd5b879416aed45523c1998f22a0b.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/goldencity3.jpg
// module id = 491
// module chunks = 0